import { Hero } from "../components/Hero";
import { VideoShowcase } from "../components/VideoShowcase";
import { ThenNowNext } from "../components/home/ThenNowNext";
import { Services } from "../components/Services";
import { GlobalImpact } from "../components/GlobalImpact";
import { Network } from "../components/Network";
import { Testimonials } from "../components/Testimonials";
import { Contact } from "../components/Contact";
import { HeritageBridge } from "../components/home/HeritageBridge";

const HomePage = ({ isLoaded }) => {
  return (
    <main>
      <Hero isLoaded={isLoaded} />
      <VideoShowcase />
      <ThenNowNext />
      <Services />
      <HeritageBridge />
      <GlobalImpact />
      <Network />
      <Testimonials />
      <Contact />
    </main>
  );
};

export default HomePage;
